import { render, staticRenderFns } from "./TaskSchedulePageV2.vue?vue&type=template&id=71d443ed&scoped=true&"
import script from "./TaskSchedulePageV2.vue?vue&type=script&lang=js&"
export * from "./TaskSchedulePageV2.vue?vue&type=script&lang=js&"
import style0 from "./TaskSchedulePageV2.vue?vue&type=style&index=0&id=71d443ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d443ed",
  null
  
)

export default component.exports